<template>
  <div class="body">
    <div class="title">
      学校列表
      <!-- 面包屑导航区域 -->
      <div class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/schoolListByApproval' }"
            ><span class="dsadf"> 入园审批 </span></el-breadcrumb-item
          >
          <el-breadcrumb-item>学校列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="static">
      已激活学校<span style="color: blue; font-weight: bold">
        {{ schoolStatistics.active_num }} </span
      >所，累计锻炼<span style="color: blue; font-weight: bold">
        {{ schoolStatistics.user_num }} </span
      >人,<span style="color: blue; font-weight: bold">{{
        schoolStatistics.open_num
      }}</span
      >人次
    </div>
    <div class="btnsearch">
      <div class="left">
        <el-input
          style="width: 320px"
          clearable
          v-model="query.title"
          placeholder="请输入学校名称搜索"
        >
          <template slot="append">
            <el-button type="primary" @click="Discountsearch">搜索</el-button>
          </template>
        </el-input>
      </div>
      <div class="right">
        <el-form :inline="true">
          <el-form-item>
            区县市
            <el-select
              disabled="true"
              style="width: 140px"
              v-model="query.city"
              placeholder="请选择区县"
            >
              <el-option
                v-for="item in [{ value: '区县市 1' }, { value: '区县市 2' }]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            街道
            <el-select
              disabled="true"
              style="width: 140px"
              v-model="query.county"
              placeholder="请选择街道"
            >
              <el-option
                v-for="item in [{ value: '街道市 1' }, { value: '街道市 2' }]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="handleAllExport">
              <i class="el-icon-download"></i>
              全部导出
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <vxe-table
      :data="applyList"
      border
      stripe
      resizable
      max-height="750"
      class="mytable-scrollbar"
      show-overflow
      keep-source
      align="center"
      :highlight-current-column="true"
    >
      <vxe-table-column field="id" title="学校ID" min-width="50">
      </vxe-table-column>
      <vxe-table-column field="account" title="账号" min-width="140">
      </vxe-table-column>
      <vxe-table-column field="title" title="学校名称" min-width="160">
      </vxe-table-column>
      <vxe-table-column field="user_num" title="累计人数" min-width="100">
      </vxe-table-column>
      <vxe-table-column field="open_num" title="累计人次" min-width="120">
      </vxe-table-column>
      <vxe-table-column field="sort" title="地址" min-width="220">
        <template slot-scope="scope">
          {{ scope.row.address }}
          <br />
        </template>
      </vxe-table-column>
      <vxe-table-column field="time" title="开放时间" min-width="80">
      </vxe-table-column>
      <vxe-table-column field="advertisement" title="公告栏" min-width="80">
      </vxe-table-column>
      <vxe-table-column title="操作" width="120" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="warning"
            size="mini"
            @click="handleChangePass(scope.row)"
          >
            重置密码
          </el-button>
        </template>
      </vxe-table-column>
    </vxe-table>
    <div v-if="pageshow">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="cur_page"
        :page-sizes="[10, 20]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getShcoolList, resetPass, getSchoolStatistics } from "@/api/school";

export default {
  name: "index",
  data() {
    return {
      dialogVisibleByNotApplroved: false,
      currentSchool: {},
      pageshow: true,
      total: null,
      query: {
        token: sessionStorage.getItem("token"),
        title: "",
        area_code: "",
        street_code: "",
        page: 1,
        pagesize: 10,
      },
      applyList: [],
      token: sessionStorage.getItem("token"),
      cur_page: 1,
      schoolStatistics: {},
    };
  },
  created() {
    this.getShcoolList();
    this.getSchoolStatistics();
  },
  methods: {
    getSchoolStatistics() {
      getSchoolStatistics().then((resp) => {
        // console.log("_getSchoolStatistics", resp.data.data);
        this.schoolStatistics = resp.data.data;
      });
    },
    handleAllExport() {
      window.open(
        `https://ydmxhapi.yundongm.cn:8099/service/admin/school/export?token=${sessionStorage.getItem(
          "token"
        )}`
      );
    },
    handleChangePass(item) {
      // console.log("_handleChangePass", item);
      this.currentSchool = item;

      this.$confirm(
        `确定将「${item.title}」密码重置为 bxydm@202304, 是否继续?`,
        "重置密码",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          beforeClose: async (action, instance, done) => {
            if (action === "cancel") return done();
            if (action === "confirm") {
              const resp = await resetPass({ id: item.id });
              // console.log(resp.data);
              if (resp.data.result == 1) {
                this.getShcoolList();
                done();
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
              } else {
                done();
                this.$message({
                  message: "操作失败",
                  type: "error",
                });
              }
            }
          },
        }
      ).catch(() => {});
    },
    handleApplicationNotApplroved(item) {
      console.log("_审核不通过", item);
      this.currentSchool = item;
      this.$nextTick(() => {
        this.dialogVisibleByNotApplroved = true;
      });
    },
    async handleNotApplroved() {
      console.log("_notapplroved", this.currentSchool);
      const resp = await applyOperate({
        id: this.currentSchool.id,
        status: "3",
        remark: this.currentSchool.remark,
      });
      console.log("_handleNotApplroved", resp);

      this.dialogVisibleByNotApplroved = false;
      setTimeout(() => {
        this.getShcoolList();
        this.currentSchool = {};
      }, 700);
    },

    Discountsearch() {
      this.cur_page = 1;
      this.getShcoolList();
      this.pageshow = false; // 让分页隐藏
      this.$nextTick(() => {
        // 重新渲染分页
        this.pageshow = true;
      });
    },
    getShcoolList() {
      getShcoolList(this.query).then(({ data: res }) => {
        this.applyList = res.data.list;
        this.total = res.data.total - 0;
        console.log("_this.getShcoolList", this.applyList);
      });
    },

    handleSizeChange(val) {
      this.query.pagesize = val;
      this.handleCurrentChange(this.query.page);
    },
    handleCurrentChange(val) {
      this.query.page = val;
      this.getShcoolList();
    },
  },
};
</script>

<style scoped lang="less">
.imgs {
  width: 130px;
  height: 70px;
  background: rgba(0, 0, 0, 0);
  border-radius: 2px;
}
.body {
  display: flex;
  flex-direction: column;
  .title {
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    margin-bottom: 35px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .fansk {
      margin-top: 30px;
      margin-left: 32px;
    }
    .dsadf {
      color: #3d9aff;
    }
  }
  .btnsearch {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .left {
      margin-right: 150px;
    }
    .right {
      margin-top: 27px;
    }
  }
}
</style>
